import { Modal, Typography } from '@otp/ui';
import { StoreModel } from 'src/graphql/generated/graphql';
import { OTPsAssignedList } from './otps-assigned-list';
import { OTPsUnassignedList } from './otps-unassigned-list';
import { useTranslation } from 'react-i18next';
import { getAddress } from 'src/utils/restaurant-data';
import { MarkerActive } from '@otp/icons';

type OTPsManagementModalProps = {
  store: Partial<StoreModel>;
  open: boolean;
  onClose: () => void;
};

export const OTPsManagementModal = ({
  store,
  open,
  onClose,
}: OTPsManagementModalProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-restaurants.otps.modals',
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="lg"
      title={
        <div className="flex items-center gap-2">
          <MarkerActive />
          {t('assignment-for')}: {store.name}, {getAddress(store)}
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        <OTPsAssignedList store={store} />
        <OTPsUnassignedList store={store} />
      </div>
    </Modal>
  );
};
